import React, { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategory,
  deleteCategory,
} from "../../redux/apiCall/categoryCall";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import ButtonComponent from "../../components/ButtonComponent";
import "../pages/Styles/Admin.css";

const TableCategory = () => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.category.categories);

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Product!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(deleteCategory(id)).then(() => {
          dispatch(getAllCategory());
        });
      }
    });
  };

  const columns = [
    { field: "_id", headerName: "ID", width: 70 },
    { field: "name", headerName: "Category Name", width: 200 },
    {
      field: "image",
      headerName: "image",
      width: 200,
      align: "center",
      headerAlign: "center",
      cellClassName: "admin-table-image-column",
      renderCell: (params) => (
        <div className="admin-table-image-cell">
          <img
            className="admin-table-image"
            src={params.row.image}
            width={100}
            height={100}
            alt={params.row.name}
          />
        </div>
      ),
    },
    {
      field: "Action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 220,
      renderCell: (params) => (
        <div className="admin-action-group">
          <Link
            to={`/admin/editcategory`}
            state={{ categoryId: params.row.id, categoryName: params.row.name }}
          >
            <button className="btn btn-primary btn-sm admin-btn-edit">Edit</button>
          </Link>
          <button
            className="btn btn-danger btn-sm admin-btn-delete"
            onClick={() => handleDelete(params.row._id)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const rows = categories.map((category) => ({
    ...category,
    id: category._id,
  }));

  useEffect(() => {
    dispatch(getAllCategory());
  }, [dispatch]);

  return (
    <div className="admin-table-wrapper">
      <div className="admin-table-toolbar">
        <Link to={"/admin/addcategory"}>
          <ButtonComponent type="submit">Add New Category</ButtonComponent>
        </Link>
      </div>
      <DataGrid rows={rows} columns={columns} pageSize={5} rowHeight={100} />
    </div>
  );
};

export default TableCategory;
